import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ContentList from '../components/content/ContentList';
import ContentDetail from '../components/content/ContentDetail';
import ContentForm from '../components/content/ContentForm';

function ContentPage() {
  return (
    <div className="page">
      <div className="container">
        <Routes>
          {/* Main content list */}
          <Route path="/" element={<ContentList />} />
          
          {/* Create new content (protected route) */}
          <Route path="/new" element={<ContentForm />} />
          
          {/* Edit existing content (protected route) */}
          <Route path="/edit/:contentId" element={<ContentForm />} />
          
          {/* View specific content by slug or ID */}
          <Route path="/:contentSlug" element={<ContentDetail />} />
        </Routes>
      </div>
    </div>
  );
}

export default ContentPage;